export const yr2020 = {
    zelfstandigenaftrek: 7030,
    startersaftrek: 2123,
    mkbVrijstelling: 14,
    zvwBijdrage: { pct: 5.45, limit: 57232 },
    arbeidskorting: [
        { low: 0, high: 9921, pct: 2.812, addition: 0 },
        { low: 9921, high: 21430, pct: 28.812, addition: 279 },
        { low: 21430, high: 34954, pct: 1.656, addition: 3595 },
        { low: 34954, high: 98604, pct: -6, addition: 3819 },
        { low: 98604, high: 999999999, pct: 0, addition: 0 }
    ],
    belasting: [
        { low: 0, high: 68507, pct: 37.35, addition: 0 },
        { low: 68507, high: 999999999, pct: 49.50, addition: 25587 },
    ],
    heffingskorting: [
        { low: 0, high: 20711, pct: 0, addition: 2711 },
        { low: 20711, high: 68507, pct: -5.672, addition: 2711 },
        { low: 68507, high: 999999999, pct: 0, addition: 0 },
    ],
    inkomenhoogsteschaal: 68507,
    tarrifaanpassing: 0.0350,
}